import { serialize } from "../formUtils.js"

class Glossary {
  constructor() {
    this.initComponents()
    this.bindEvents()
    this.showSummaries()
  }

  initComponents() {
    this.form = document.querySelector("form[name=glossary__filters]")
    this.radioButtons = document.querySelectorAll("input[name='letter']")
    this.container = document.querySelector(".glossary__entries")
    this.entries = document.querySelectorAll(".glossary-entry")
    this.spinner = document.querySelector("[data-spinner]")
  }

  bindEvents() {
    this.radioButtons.forEach(button => {
      button.addEventListener("change", () => {
        this.getEntries()
      })
    })
  }

  getEntries() {
    // selected filters
    const queryParams = serialize(this.form)

    // update view
    this.spinner.style.display = "block"
    this.container.innerHTML = null

    // send request
    var xhr = new XMLHttpRequest()
    xhr.open("GET", "/glossary?" + queryParams)
    xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest")
    xhr.onload = () => this.replaceArticles(xhr.status, xhr.response)
    xhr.send()
  }

  replaceArticles(status, articleHtml) {
    this.spinner.style.display = "none"

    this.container.innerHTML = articleHtml
    this.entries = document.querySelectorAll(".glossary-entry")
    this.showSummaries()
  }

  showSummaries() {
    this.entries.forEach((summary, index) => {
      let delay = index * 50
      setTimeout(this.fadeIn(summary), delay)
    })
  }

  fadeIn(summary) {
    return function() {
      summary.style.opacity = 1
    }
  }
}

export default function init() {
  if (document.querySelector(".GlossaryPage")) {
    new Glossary()
  }
}
